module.exports = __webpack_public_path__ + "media/hyper/images/users/avatar-9-effcd89f3d82672513777065799fcfec.jpg";